import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

enum CalendarEvent {
    START_GOOGLE_CALENDAR_AUTH = "start_google_calendar_auth",
    COMPLETE_GOOGLE_CALENDAR_AUTH = "complete_google_calendar_auth",
    ERROR_GOOGLE_CALENDAR_AUTH = "error_google_calendar_auth",
    SIGN_OUT_GOOGLE_CALENDAR = "sign_out_google_calendar",

    START_OUTLOOK_CALENDAR_AUTH = "start_outlook_calendar_auth",
    COMPLETE_OUTLOOK_CALENDAR_AUTH = "complete_outlook_calendar_auth",
    ERROR_OUTLOOK_CALENDAR_AUTH = "error_outlook_calendar_auth",
    SIGN_OUT_OUTLOOK_CALENDAR = "sign_out_outlook_calendar",

    ADD_TASK_TO_CALENDAR = "add_task_to_calendar",
    JOIN_CALENDAR_EVENT_MEETING = "join_calendar_event_meeting",
    CHANGE_SELECTED_CALENDAR = "change_selected_calendar",
    OPEN_CALENDAR_LINK = "open_calendar_link",
}

export type CalendarIntegrationEventSource = "onboarding" | "widget" | "week_view";

enum OutlookSignoutEventProperties {
    MENUBAR = "menubar",
    MAIN_WINDOW = "desktop_app_main_window",
    BROWSER = "browser",
}

class StartGoogleCalendarAuthEvent extends AmplitudeEvent {
    constructor(eventSource: CalendarIntegrationEventSource) {
        super(CalendarEvent.START_GOOGLE_CALENDAR_AUTH);
        this.props = { eventSource: eventSource };
    }
}

class CompleteGoogleCalendarAuthEvent extends AmplitudeEvent {
    constructor() {
        super(CalendarEvent.COMPLETE_GOOGLE_CALENDAR_AUTH);
    }
}

class ErrorGoogleCalendarAuthEvent extends AmplitudeEvent {
    constructor(errorDetails: string) {
        super(CalendarEvent.ERROR_GOOGLE_CALENDAR_AUTH);
        this.props = { errorDetails: errorDetails };
    }
}

class SignOutOfGoogleCalendarEvent extends AmplitudeEvent {
    constructor() {
        super(CalendarEvent.SIGN_OUT_GOOGLE_CALENDAR);
    }
}

class StartOutlookCalendarAuthEvent extends AmplitudeEvent {
    constructor(eventSource: CalendarIntegrationEventSource) {
        super(CalendarEvent.START_OUTLOOK_CALENDAR_AUTH);
        this.props = { eventSource: eventSource };
    }
}

class CompleteOutlookCalendarAuthEvent extends AmplitudeEvent {
    constructor() {
        super(CalendarEvent.COMPLETE_OUTLOOK_CALENDAR_AUTH);
    }
}

class ErrorOutlookCalendarAuthEvent extends AmplitudeEvent {
    constructor(errorDetails: string) {
        super(CalendarEvent.ERROR_OUTLOOK_CALENDAR_AUTH);
        this.props = { errorDetails: errorDetails };
    }
}

class SignOutOfOutlookCalendarEvent extends AmplitudeEvent {
    constructor(signOutSource: OutlookSignoutEventProperties) {
        super(CalendarEvent.SIGN_OUT_OUTLOOK_CALENDAR);
        this.props = { source: signOutSource };
    }
}

class ChangeSelectedCalendarEvent extends AmplitudeEvent {
    constructor() {
        super(CalendarEvent.CHANGE_SELECTED_CALENDAR);
    }
}

class JoinCalendarEventMeetingEvent extends AmplitudeEvent {
    constructor() {
        super(CalendarEvent.JOIN_CALENDAR_EVENT_MEETING);
    }
}

class OpenCalendarLinkEvent extends AmplitudeEvent {
    constructor() {
        super(CalendarEvent.OPEN_CALENDAR_LINK);
    }
}

export {
    StartGoogleCalendarAuthEvent,
    CompleteGoogleCalendarAuthEvent,
    ErrorGoogleCalendarAuthEvent,
    SignOutOfGoogleCalendarEvent,
    StartOutlookCalendarAuthEvent,
    CompleteOutlookCalendarAuthEvent,
    ErrorOutlookCalendarAuthEvent,
    SignOutOfOutlookCalendarEvent,
    ChangeSelectedCalendarEvent,
    JoinCalendarEventMeetingEvent,
    OpenCalendarLinkEvent,
    OutlookSignoutEventProperties,
};
